exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".browse-brand__item[data-v-e70c8c1e] {\n  -webkit-border-image: url(\"/assets/pattern-tile.png\") 20;\n       -o-border-image: url(\"/assets/pattern-tile.png\") 20;\n          border-image: url(\"/assets/pattern-tile.png\") 20;\n}\n", ""]);

// exports
